import { ReactNode } from 'react';
import ReactModal from 'react-modal';
import { createGlobalStyle } from 'styled-components';

import { Z_INDICES } from 'dashboard/styles/variables';

const REACT_MODAL_TRANSITION_TIME = 150;

// Based off instructions here:
//
// https://github.com/reactjs/react-modal/blob/master/docs/styles/transitions.md
const ReactModalStyle = createGlobalStyle`
  .ReactModal__Overlay {
      opacity: 0;
      transition: opacity ${REACT_MODAL_TRANSITION_TIME}ms ease-in-out;
  }

  .ReactModal__Overlay--after-open{
      opacity: 1;
  }

  .ReactModal__Overlay--before-close{
      opacity: 0;
  }
`;

const modalStyles: ReactModal.Styles = {
  overlay: {
    overflowY: 'scroll',
    zIndex: Z_INDICES.modal,
    backgroundColor: 'rgba(0,0,0, .8)',
  },
  content: {
    top: '60px',
    left: '0px',
    right: '0px',
    bottom: 'unset',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: 0,
    padding: 0,
    width: 'max-content',
    background: 'none',
  },
};

interface ModalWrapperProps {
  isOpen: boolean;
  children: ReactNode;
  styleOverride?: ReactModal.Styles;
  handleCloseModal?: () => void;
  shouldCloseOnEsc?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  contentLabel?: ReactModal.Props['contentLabel'];
}

const ModalWrapper = ({
  isOpen,
  children,
  styleOverride = { overlay: {}, content: {} },
  handleCloseModal,
  shouldCloseOnEsc,
  shouldCloseOnOverlayClick,
  contentLabel,
}: ModalWrapperProps) => {
  return (
    <>
      <ReactModalStyle />
      <ReactModal
        contentLabel={contentLabel}
        isOpen={isOpen}
        // passing in a handleCloseModal allows for triggering close on esc and overlay click
        onRequestClose={handleCloseModal}
        shouldCloseOnEsc={shouldCloseOnEsc}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={{
          overlay: {
            ...modalStyles.overlay,
            ...styleOverride.overlay,
          },
          content: {
            ...modalStyles.content,
            ...styleOverride.content,
          },
        }}
      >
        {children}
      </ReactModal>
    </>
  );
};

export default ModalWrapper;
